import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendDeliveryByEmail = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const SendDeliveryEmailWithPDF = () => {
    setLoading(true)
    new rest.DeliveryService(ticket.delivery.url)
      .send_delivery_details_by_email_with_pdf()
      .then(() => {
        dispatch(showSuccessToast('Sent Delivery Details By Email With PDF'))
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Delivery Details By Email'))
      })
  }

  return (
    <ReactBootstrap.Dropdown.Item onClick={() => SendDeliveryEmailWithPDF()}>
      {loading ? (
        <components.Loading />
      ) : (
        'Send Delivery Details By Email With PDF'
      )}
    </ReactBootstrap.Dropdown.Item>
  )
}
